import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Krida page error:", error, info);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.routeKey !== this.props.routeKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="page-error-boundary">
          <AlertTriangle className="w-10 h-10 text-krida-crimson mb-4" />
          <h2 className="font-heading text-2xl font-bold">Something went wrong on this screen</h2>
          <p className="text-slate-500 mt-2 max-w-md">Please try navigating again or reloading. The rest of Krida is unaffected.</p>
          <button onClick={() => window.location.reload()} className="mt-6 px-5 py-2.5 rounded-xl bg-krida-crimson hover:bg-krida-crimsonDark font-semibold transition-colors">Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
